import { useMemo } from "react";
import { useCatalog } from "@/lib/catalog/context.tsx";
import { groupBySection } from "@/lib/catalog/index.ts";
import { useFilteredRoad } from "@/lib/filters/context.tsx";
import { resetFilters } from "@/state/filters.ts";
import { PartSection } from "./PartSection.tsx";
import styles from "./RoadList.module.css";

export function RoadList() {
  const catalog = useCatalog();
  const { visible, entries } = useFilteredRoad();
  const sections = useMemo(() => groupBySection(catalog, visible), [catalog, visible]);

  if (entries.length === 0) {
    return (
      <div className={styles.empty}>
        <h2 className={styles.emptyTitle}>Nothing survives these filters.</h2>
        <p>
          That combination has no stops on it, most often a character or thread that nothing else
          you've allowed sets up. Loosen the importance ceiling or clear a chip.
        </p>
        <button type="button" className={styles.emptyReset} onClick={resetFilters}>
          Reset filters
        </button>
      </div>
    );
  }

  return (
    <div className={styles.road}>
      {sections.map(({ section, entries: sectionEntries, total }) => (
        <PartSection key={section.id} section={section} entries={sectionEntries} total={total} />
      ))}
    </div>
  );
}
